import { Observable, of } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map, catchError, tap } from 'rxjs/operators';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { EventDTO } from '../../../../dto/event/event.dto';
import { environment } from '../../../../environment/environment';

export function events_with_catering(
  componentDataSourceService: ComponentDataSourceService,
  http: HttpClient,
  router: Router
) {
    return {
      name: 'Events with Catering',
      description: 'Liste af alle events med inkluderet catering',
      execute: (params?: LoadDataParams) => {
        
        // Log the sort parameters specifically
        if (params?.sort) {
        } else {
        }

        // Build query parameters to filter for catering_included events
        const queryParams: any = {};
        
        // Add catering filter as a direct query parameter
        queryParams.catering = 'catering_included';
        
        // Handle standard search query
        if (params?.searchQuery) {
          queryParams.search = params.searchQuery;
        }
        
        // Handle additional filters from LoadDataParams
        if (params?.filters?.length) {
          queryParams.filters = JSON.stringify(params.filters);
        }

        // Handle sort parameters
        if (params?.sort) {
          queryParams.sort = JSON.stringify(params.sort);
        }

        
        return http.get<EventDTO[]>(`${environment.apiUrl}/events`, {
          params: queryParams
        }).pipe(
          catchError(error => {
            console.error('Error fetching events with catering:', error);
            return of({ items: [], totalCount: 0 });
          }),
          map(result => {
            if (result && Array.isArray(result)) {
              try {
                // Backend should already filter by catering, but add client-side check for safety
                const eventsWithCatering = result.filter((event: EventDTO) => 
                  event.catering === 'catering_included'
                );

                return {
                  items: eventsWithCatering,
                  totalCount: eventsWithCatering.length,
                  pageSize: 10,
                  pageIndex: 0,
                  filters: params?.filters || []
                };
              } catch (error) {
                console.error('Error processing events with catering:', error);
                return { items: [], totalCount: 0 };
              }
            } else {
              console.warn('No events found or unexpected response format');
              return { items: [], totalCount: 0 };
            }
          })
        );
      },
      settings: {
        columns: [
          { 
            key: 'event_type', 
            header: 'Type', 
            type: 'text',
            transform: (value: string) => {
              switch(value) {
                case 'education': return 'Uddannelse';
                case 'course': return 'Kursus';
                case 'exercise': return 'Øvelse';
                default: return value;
              }
            }
          },
          { 
            key: 'organization', 
            header: 'Organisation', 
            type: 'text',
            transform: (value: any) => value?.name || 'N/A'
          },
          { 
            key: 'start_date', 
            header: 'Start Dato', 
            type: 'date',
            sortable: true
          },
          { 
            key: 'end_date', 
            header: 'Slut Dato', 
            type: 'date',
            sortable: true
          },
          { 
            key: 'description', 
            header: 'Beskrivelse', 
            type: 'text',
            transform: (value: any) => {
              if (value && typeof value === 'object') {
                return value.da || value.title || 'Ingen beskrivelse';
              }
              return value || 'Ingen beskrivelse';
            },
            width: '300px'
          },
          { 
            key: 'visibility', 
            header: 'Synlighed', 
            type: 'text',
            transform: (value: string) => {
              switch(value) {
                case 'public': return 'Offentlig';
                case 'private': return 'Privat';
                case 'shared': return 'Delt';
                default: return value;
              }
            }
          },
          { 
            key: 'price', 
            header: 'Pris', 
            type: 'text',
            transform: (value: number) => {
              return value > 0 ? `${value} DKK` : 'Gratis';
            },
            alignment: 'right'
          },
          {
            key: 'actions',
            header: '',
            type: 'button',
            buttonText: 'Åbn',
            buttonColor: 'primary',
            alignment: 'right',
            variant: 'raised',
            action: (row: EventDTO) => {
              // TODO: Implement modal opening logic here
              // For now, we'll just log the event
              alert(`Modal for event ${row.event_id} will be implemented`);
            }
          }
        ],
        pageable: true,
        sortable: true,
        rowHover: true,
        searchable: true,
        defaultSortColumn: 'start_date',
        defaultSortDirection: 'asc'
      }
    }
} 